//----------------------- rem -------------------------//
// rem
// rem
// 设计稿宽度 : 750  ( 2倍图 )
// 缩放比例 : 100   ( 1rem === 100px )
export const remJs = psd => {
  setRootFontSize(psd)
  window.addEventListener('resize', () => {
    setRootFontSize(psd)
  }, !1)
}

function setRootFontSize(psd) {
  let docWidth = document.documentElement.getBoundingClientRect().width
  document.documentElement.style.fontSize = docWidth / psd * 100 + 'px'
}


//----------------------- rem to px -------------------------//
// rem to px
export const remToPx = r => {
  let Ppx = parseInt(document.documentElement.style.fontSize);
  return r * Ppx
}

//----------------------- 进度条 -------------------------//
// 1-100 进度
// inter(
//   // 第一个数组里是卡住的数字节点
//   // 第二个数组是速度
//   // [[32, 55, 63, 71, 85, 98], [100, 300, 160, 100, 50, 700]],
//   s => {
//     // s 是数字
//     this.loadingNum = s;
//   },
//   () => {
//     // 100 %
//     this.hideShow();
//   }
// );
export const inter = (arr, s, callback) => {
  let t,
    num = 0,
    speedNum = 50;
  let interval = () => {
    num++;
    s(num);
    let index = arr[0].findIndex(value => value === num);
    if (index >= 0) {
      clearInterval(t);
      t = setInterval(interval, arr[1][index]);
    }
    // 停止
    if (num === 100) {
      clearInterval(t);
      callback(); // 回调函数
    }
  };
  t = setInterval(interval, speedNum);
}





//----------------------- 获取body的宽高 -------------------------//
// 获取body的宽高
export const getBodyWH = () => {
  return {
    width: document.documentElement.clientWidth || document.body.clientWidth || window.clientWidth,
    height: document.documentElement.clientHeight || document.body.clientHeight || window.clientHeight
  }
}

//----------------------- 判断是否横屏 -------------------------//

export const HS = ca => {

  window.onorientationchange = function () {
    if (window.orientation == 90 || window.orientation == -90) {
      ca(true) // 横屏了
    } else {
      ca(false) // 没有横屏
    }
  }
  window.onorientationchange()
}

// 返回设备类型
export const device = () => {
  let userAgentInfo = navigator.userAgent;
  let Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  ];

  for (let i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) > 0) {
      return Agents[i];
    }
  }
  return 'Pc'
};



//----------------------- 加载外部字体 -------------------------//
// 解决在外部字体没有加载进来页面文字不显示问题
export const loadFont = (font, callback) => {

  let num = 0
  let fontL = 0
  if (Object.prototype.toString.call(font) === "[object Array]") {
    fontL = font.length;
    for (let i = 0; i < font.length; i++) {
      createSpan(font[i])
    }
  } else {
    fontL = 1
    createSpan(font)
  }


  function createSpan(f) {
    let span = document.createElement("span") // 创建一个span

    setCss(span, f) // 设置css样式
    // 设置span的字体为外部字体
    document.body.appendChild(span)
    let width_now = span.offsetWidth // 获取span的初始宽度

    let interval_check = setInterval(function () {
      if (span.offsetWidth != width_now) { // 当宽度改变后说明字体加载完成了
        clearInterval(interval_check)
        num++
        document.body.removeChild(span)
        span = null
        num === fontL && callback()
      }
    }, 30)
  }

  // 设置css样式
  function setCss(span, f) {
    span.innerHTML = "gW@i#Q!T"
    span.style.visibility = "hidden"
    span.style.fontSize = "50px"
    span.style.opacity = 0;
    span.style.position = 'absolute'
    span.style.bottom = 0
    span.style.left = 0
    span.style.zIndex = -1
    span.style.fontFamily = "Microsoft YaHei"
    setTimeout(() => {
      span.style.fontFamily = f
    }, 1000)
  }
}

// 判断是否是微信浏览器
export const isWeiXin = () => {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true; // 是微信浏览器
  } else {
    return false; // 不是微信浏览器
  }
}